import { useMaxWith, WebWrapper } from '../../../components/WebWrapper'

import { ActionSheetFoundation, ActionSheetProps } from './ActionSheetFoundation'

export * from './ActionSheetFoundation'
export default (props: ActionSheetProps) => {
  const maxWidth = useMaxWith()
  return (
    <WebWrapper>
      <ActionSheetFoundation {...props} maxWidth={maxWidth} />
    </WebWrapper>
  )
}
